<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="order.owner.id" :options="owners" placeholder="placeholder.pleaseSelectOwner" @change="onOwnerChange"/>
        <vxe-select v-if="automatic" v-model="order.transferType" :options="transferTypes" placeholder="placeholder.pleaseSelectTransferType"/>
      </template>
      <template #extra>
        <vxe-button content="button.taken" icon="vxe-icon-search" status="primary" @click="fetch"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="clear"/>
        <vxe-button :disabled="details.length===0" content="button.save" icon="vxe-icon-save" status="primary" @click="save"/>
      </template>
      <vxe-table
        ref="table"
        :checkbox-config="{trigger: 'row'}"
        :data="details"
        :edit-config="editConfig"
        :edit-rules="editRules"
        :height="height"
        :loading="loading"
        keep-source>
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="200"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="200"/>
        <vxe-column v-if="automatic" field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column field="sourceLocation.no" title="business.label.sourceLocation" width="120"/>
        <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom" width="120"/>
        <vxe-column field="sourceLogicalStore.name" title="business.label.sourceLogicalStore" width="100"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',enabled:!automatic}" field="quantity" title="title.quantity" width="100"/>
        <vxe-column :edit-render="{name:'VxeInput',enabled:!automatic,events:{click:({row})=>onStorageRoomSelect(row)}}" field="targetStorageRoom.name" title="title.targetStorageRoom" width="120"/>
        <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>onLocationSelect(row)}}" field="targetLocation.no" title="title.moveInLocation" width="120"/>
        <vxe-column :edit-render="logicalStoreRender" field="targetLogicalStore.name" title="title.targetLogicalStore" width="120"/>
        <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>onReasonSelect(row)}}" field="reason.name" title="title.reason"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <InventoryModal ref="inventoryModal" :select-type="'checkbox'" @change="onInventoryChange"/>
    <StorageRoomModal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <LocationModal ref="locationModal" @change="onLocationChange"/>
    <FieldModal ref="reasonModal" :show-name="true" :show-no="false" :show-value="false" no="REASON" title="原因" @change="onReasonChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import InventoryModal from '@/views/modal/InventoryModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import Api from '@/api'
import FieldModal from '@/views/modal/FieldModal.vue'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Location } from '@/api/dto/common/Location'
import { TransferOrder } from '@/api/dto/order/TransferOrder'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'MoveTemplate',
  components: { FieldModal, InventoryModal, LocationModal, StorageRoomModal },
  props: {
    orderType: [Object],
    type: [String],
    automatic: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new TransferOrder(),
      details: [],
      owners: [],
      transferTypes: [],
      logicalStores: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8375),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        quantity: [
          { required: true, type: 'number', min: 1, message: '移库数量需大于0' }
        ],
        'targetLocation.no': [
          { required: !this.automatic, type: 'string', message: '目标货位不能为空' }
        ]
      },
      logicalStoreRender: {
        name: 'VxeSelect',
        enabled: !this.automatic,
        options: this.logicalStores
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getDictionaries('LOGICAL_STORE')
    }).then(result => {
      this.logicalStores = result
      if (this.automatic) {
        getEnums('TransferType').then(result => {
          this.transferTypes = result.filter(item => item.value !== 0)
        })
      } else {
        this.order.transferType = 0
      }
    })
  },
  methods: {
    onOwnerChange() {
      this.details = []
    },
    onInventoryChange(data) {
      this.details = data.map(item => {
        let detail = JSON.parse(JSON.stringify(item))
        detail.quantity = Number(detail.inventory.availableOutboundQuantity)
        detail.sourceLocation = new Location(detail.location)
        detail.targetLocation = new Location()
        detail.sourceStorageRoom = new StorageRoom(detail.storageRoom)
        detail.sourceLogicalStore = new Dictionary(detail.logicalStore)
        detail.targetLogicalStore = new Dictionary(detail.logicalStore)
        if (this.automatic) {
          detail.targetStorageRoom = new StorageRoom(detail.storageRoom)
        } else {
          detail.targetStorageRoom = new StorageRoom()
        }
        detail.reason = new Dictionary()
        return detail
      })
    },
    onStorageRoomSelect(row) {
      this.$refs.storageRoomModal.open({ available: true, physical: true }, row)
    },
    onStorageRoomChange(data, row) {
      row.targetStorageRoom = new StorageRoom(data[0])
      row.targetLocation = new Location()
    },
    onLocationSelect(row) {
      if (row.targetStorageRoom.isNew()) {
        return this.$warning({ title: '请先选择目的库房', centered: true })
      }
      this.$refs.locationModal.open({ available: true, 'storageRoom.id': row.targetStorageRoom.id }, row)
    },
    onLocationChange(data, row) {
      row.targetLocation = new Location(data[0])
    },
    onReasonSelect(row) {
      this.$refs.reasonModal.open({ available: true }, row)
    },
    onReasonChange(data, row) {
      row.reason = new Dictionary(data[0])
    },
    fetch() {
      if (this.order.owner.isNew()) {
        return this.$message.warning('请先选择货主')
      }
      let args = { 'owner.id': this.order.owner.id, available: true, physical: true }
      if (this.automatic) {
        args.device = true
      }
      this.$refs.inventoryModal.open(args)
    },
    reset() {
      this.order = new TransferOrder()
      this.details = []
      if (!this.automatic) {
        this.order.transferType = 0
      }
    },
    clear() {
      let that = this
      that.$confirm({
        title: '将清空界面数据',
        content: '是否确定',
        onOk() {
          that.reset()
        },
        onCancel() {
        },
        centered: true
      })
    },
    remove(row) {
      this.details.splice(this.details.indexOf(row), 1)
    },
    verify() {
      let pass = true
      if (this.order.transferType === undefined) {
        this.$message.warning('请选择移库类型')
        pass = false
        return pass
      }
      return pass
    },
    async save() {
      if (!this.verify()) {
        return
      }
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      order.orderType = this.orderType
      order.dataSource = 4
      order.details = this.details.map(item => {
        const detail = {
          sku: { id: item.sku.id },
          sourceLocation: item.sourceLocation.skipNulls(),
          targetLocation: item.targetLocation.skipNulls(),
          inventoryState: item.inventory.inventoryState,
          storageRoom: item.targetStorageRoom.skipNulls(),
          logicalStore: item.targetLogicalStore.skipNulls(),
          quantity: item.quantity,
          reason: item.reason.skipNulls()
        }
        if (this.automatic) {
          detail.sourceContainer = item.container
          detail.targetContainer = item.container
        }
        return detail
      })
      post(Api.transferSubmit, { type: this.type }, order).then(res => {
        if (res.success) {
          this.details = []
          this.$message.success(this.$t('message.saveSuccess'))
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>